.atm_gq_1tcgj5g.atm_gq_1tcgj5g{margin-bottom:24px;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1y6m0gg.atm_h_1y6m0gg{align-items:flex-start;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_gz_1bs0ed2.atm_gz_1bs0ed2{margin-left:-8px;}
.atm_h0_1bs0ed2.atm_h0_1bs0ed2{margin-right:-8px;}
.atm_1ejqrtk_ftgil2.atm_1ejqrtk_ftgil2>*{margin-left:8px;}
.atm_ks7y7w_ftgil2.atm_ks7y7w_ftgil2>*{margin-right:8px;}
.atm_xx2s9_1v0jjvg.atm_xx2s9_1v0jjvg>*{flex-basis:calc(100% / var(--form-row-count));}
.atm_xx2s9_19sutnk.atm_xx2s9_19sutnk>*{flex-basis:var(--form-row-col-basis, auto);}
.atm_ibce0z_jqx7k9>*{width:calc(var(--form-row-single-basis) - 1px);}
